import api from "../../api";
import { getOnboardingFilesEndpoint } from "../../api/apisUrl";
import { apiError } from "../../models";
import {
  GET_ONBOADINGFILES_LOADING,
  GET_ONBOADINGFILES_FAILED,
  GET_ONBOADINGFILES_REMOVE,
  GET_ONBOADINGFILES_SUCCESS
} from "../types";





const initialState = {
  loading: false,
  error: null,
  status: null,
  filesNames: null,
};

export const getOnBoardingFilesReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
  switch (action.type) {
    case GET_ONBOADINGFILES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_ONBOADINGFILES_SUCCESS:
      return {
        ...state,
        loading: false,
        filesNames: action.payload,
        status: action.status,
        error: null,
      };
    case GET_ONBOADINGFILES_FAILED:
      return {
        ...state,
        loading: false,
        status: action.status,
        error: action.error,
        filesNames: null,

      };
    case GET_ONBOADINGFILES_REMOVE:
      return initialState

    default:
      return state;
  }
};




